import _ from "lodash";
import moment from "components/moment";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { statsAPI, setSuccess } from "redux/api";

import AttrsPieChart from "components/stats/AttrsPieChart";
import AttrsLineChart from "components/stats/AttrsLineChart";

import { StatsContainer, StatsComponent, defaultQuery } from "components/stats/init";

const { api } = statsAPI.actions;

const ProgressSummaryStats = (props) => {
  useEffect(() => {}, []);

  return (
    <StatsContainer>
      <StatsComponent>
        <AttrsPieChart
          queryHandler={api.get("/messages/progress")}
          dataAttr={"statsCount"}
          title="Прослушивания по прогрессу"
        />
      </StatsComponent>
      <StatsComponent>
        <AttrsPieChart
          queryHandler={api.get("/messages/progress")}
          dataAttr={"dataCount"}
          title="Файлы по прогрессу"
        />
      </StatsComponent>
      <StatsComponent>
        <AttrsLineChart
          queryHandler={api.get("/messages/progress")}
          title="Динамика по прогрессу для прослушиваний"
          dataAttr={"statsCount"}
          query={defaultQuery()}
        />
      </StatsComponent>
      <StatsComponent>
        <AttrsLineChart
          queryHandler={api.get("/messages/progress")}
          title="Динамика по прогрессу для файлов"
          dataAttr={"dataCount"}
          query={defaultQuery()}
        />
      </StatsComponent>
    </StatsContainer>
  );
};

export default connect(null, {
  // getCharsStats: api.get("/chars"),
  // getCharsDynamic: api.get("/chars/dynamic"),
})(ProgressSummaryStats);
